import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {Module} from '../../models/models';
import {Translation} from '../../models/translation';
import {LoginService} from '../../services/login.service';
import {CheckService} from '../../services/check.service';

@Component({
  selector: 'app-logistics',
  templateUrl: './logistics.component.html',
  styleUrls: ['./logistics.component.css']
})
export class LogisticsComponent implements OnInit {

  public translation: Translation;
  public logisticsTaskModule: Module;

  constructor(
    private loginService: LoginService,
    private checkService: CheckService,
    private router: Router,
  ) { }

  ngOnInit() {
    window.scrollTo(0, 0);
    this.loginService.checkToken();
    this.checkService.checkModule(55);
    this.translation = JSON.parse(localStorage.getItem('Translation'));
    this.logisticsTaskModule = new Module();
    this.logisticsTaskModule.ModuleName = this.translation.LogisticsTaskCardTitle;
    this.logisticsTaskModule.ModuleDesc = this.translation.LogisticsTaskCardDesc;
    this.logisticsTaskModule.ModuleButtonText = this.translation.LogisticsTaskCardAction;
    this.logisticsTaskModule.ForwardLink = '/logistics-task';
  }

  navigate(forwardLink: string) {
    this.router.navigate([forwardLink]);
  }
}
